import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentType from "../enums/fragment-type";
import FragmentSummary from "./fragment-summary";
import YardConverter from "../../common/utils/yard-converter";
import TeamSide from "../enums/team-side";

export default class UpdateContext extends Fragment {
    constructor() {
        super();

        this.values;
        this.fragmentType = FragmentType.Update;

        this.requiredData = [
            {
                name: "values",
                type: FragmentDataType.UpdateContext,
                displayName: "Update Field"
            }
        ];
    }

    // eslint-disable-next-line no-unused-vars
    summarize(summaryContext, stringifier) {
        const { homeTeam, awayTeam } = summaryContext;
        const { teamName: homeTeamName } = homeTeam || "HOME";
        const { teamName: awayTeamName } = awayTeam || "AWAY";

        const {
            fieldPosition,
            down,
            firstDownAt,
            teamPossession,
            awayScore,
            homeScore,
            firstDownYardSet,
            previousFirstDownYardSet
        } = this.values || {};

        const yardConverter = new YardConverter(
            summaryContext.gameConfig.general.fieldLength
        );

        const formatFieldPosition = (pos) => {
            const { teamSide, yard } =
                yardConverter.convertFromFieldPosition(pos);
            return `${
                teamSide === TeamSide.Home
                    ? homeTeam?.abbrName || TeamSide.Home
                    : awayTeam?.abbrName || TeamSide.Visitor
            }${yard}`;
        };

        const newBallSpot = formatFieldPosition(fieldPosition);
        const prevBallSpot = formatFieldPosition(summaryContext.fieldPosition);

        const newYardToGain = formatFieldPosition(firstDownAt);
        const prevYardToGain = formatFieldPosition(summaryContext.firstDownAt);

        const prevPossession = summaryContext.homeTeamHasPossession
            ? homeTeamName
            : awayTeamName;
        const newPossession =
            teamPossession === homeTeam.id ? homeTeamName : awayTeamName;

        const prevScore = summaryContext.score || [0, 0];

        // Crew-edited zone-to-gain spot set (display-only; persisted via the
        // config save, not this fragment). Format each spot like a field spot.
        const formatSpots = (spots) =>
            Array.isArray(spots)
                ? spots.map(formatFieldPosition).join(", ")
                : "";

        const changes = [
            {
                name: "Ball spot",
                prev: prevBallSpot,
                value: newBallSpot
            },
            {
                name: "Down",
                prev: String(summaryContext.down),
                value: String(down)
            },
            {
                name: "Yard to gain",
                prev: prevYardToGain,
                value: newYardToGain
            },
            {
                name: "Team possession",
                prev: prevPossession,
                value: newPossession
            },
            {
                name: "Score",
                prev: `${awayTeamName}:${prevScore[1]} - ${homeTeamName}:${prevScore[0]}`,
                value: `${awayTeamName}:${awayScore} - ${homeTeamName}:${homeScore}`
            },
            {
                name: "Zone to gain",
                prev: formatSpots(previousFirstDownYardSet),
                value: formatSpots(firstDownYardSet)
            }
        ]
            .filter((e) => e.prev !== e.value)
            .map((e) => `${e.name}: ${e.prev} → ${e.value}`);

        return new FragmentSummary("Changes:", "Update Field", changes);
    }

    updateSummaryContext(summaryContext) {
        summaryContext.sopPrinted = true;
        summaryContext.eopPrinted = true;
    }
}
